import { PAGE_ROUTES } from '@apps/landing/src/app/shared/constants/routes.enum';

export const contacts = [
  {
    icon: 'phone',
    title: '+373 693 97 993',
  },
  {
    icon: 'mail',
    title: 'office@sapec.md',
  },
  {
    icon: 'map-pin',
    title: '45 Puskin str. office 700, MD-2005, Chisinau, Rep. of Moldova',
  },
];

export const socials = [
  {
    link: 'https://www.facebook.com/SapecSoftware',
    icon: 'assets/media/icons/facebook.svg',
  },
  {
    link: 'https://www.instagram.com/sapecsoftware',
    icon: 'assets/media/icons/instagram.svg',
  },
  {
    link: 'https://www.linkedin.com/company/sapecsoftware',
    icon: 'assets/media/icons/linkedin.svg',
  },
];

export const categories = [
  {
    title: 'Pages',
    items: [
      {
        title: 'Services',
        link: PAGE_ROUTES.SERVICES,
      },
      {
        title: 'About Us',
        link: PAGE_ROUTES.ABOUT_US,
      },
      {
        title: 'Careers',
        link: PAGE_ROUTES.CAREERS,
      },
      {
        title: 'Hire Us',
        link: PAGE_ROUTES.HIRE_US,
      },
    ],
  },
  {
    title: 'Legal',
    items: [
      {
        title: 'Terms & Conditions',
        link: PAGE_ROUTES.HOME,
      },
      {
        title: 'Privacy Policy',
        link: PAGE_ROUTES.HOME,
      },
    ],
  },
];
